import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { ProtectedRoleNoCliente } from "../hooks/roles/ProtectedRoleNoCliente";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
const ErrorPage = React.lazy(() => import("../components/error-page"));
const TareaDetalleReunion = React.lazy(
  () =>
    import(
      "../components/task/tecnical/tareaDetalleReunion/tarea-detalle-reunion"
    )
);
export function tareaDetalleReunion() {
  return (
    <Route
      path="/tarea-detalle-reunion"
      element={
        <LazySuspense>
          <ProtectedRoute>
            <ProtectedRoleNoCliente>
              <LazySuspense>
                <TareaDetalleReunion />
              </LazySuspense>
            </ProtectedRoleNoCliente>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
